import { Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges } from '@angular/core';
import { Customer } from '@inyova/models';

import { Store } from '@ngrx/store';
import { Subject } from 'rxjs';
import * as StrategyActions from '@strategy/strategy.actions';

import { TrackingService } from '@shared/services/tracking.service';

@Component({
  selector: 'app-dialog-discarded-wishes',
  templateUrl: './dialog-discarded-wishes.component.html',
  standalone: false
})
export class DialogDiscardedWishesComponent implements OnChanges, OnDestroy, OnInit {
  protected readonly onDestroy$ = new Subject<void>();
  @Input() discardedWishes: string[];
  @Input() stepStatus: number;
  @Input() kind: '3b' | '3a' | 'kid';
  customer: Customer;

  constructor(
    private store: Store,
    private trackingService: TrackingService
  ) {}

  ngOnInit(): void {
    this.trackingService.trackActivity('[Modal] Discard wishes opened');
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.discardedWishes) {
      this.discardedWishes = changes.discardedWishes.currentValue;
    }
  }

  goToTab(tabIndex: number): void {
    this.store.dispatch(StrategyActions.setDiscardedWishesDialog({ modalOpened: true, redirectUrl: '', discardedWishesDialog: true }));
    this.store.dispatch(StrategyActions.setTabIndex({ tabIndex }));
    this.trackActivity(tabIndex);
  }

  trackActivity(tabIndex: number): void {
    if (tabIndex === 5) {
      this.trackingService.trackActivity('[Button] Go back to wishlist');
    } else {
      this.trackingService.trackActivity('[Button] Continue to strategy');
    }
  }

  ngOnDestroy(): void {
    this.onDestroy$.next();
    this.onDestroy$.complete();
    this.trackingService.trackActivity('[Modal] Discard wishes closed');
  }
}
